module.exports = __webpack_public_path__ + "static/esp32-banner-v2-a7d2bb8cc519047b7e8b2a3b91883f75.png";